import { createReducer } from "@reduxjs/toolkit";
import { completeLegacyBatch, resetCompleteLegacyBatch } from "./complete-legacy-batch";
import type { ProcessingState } from "@redux/state/shared-types";

const initialState: ProcessingState = { processing: "idle" };

export const completeLegacyBatchReducer = createReducer<ProcessingState>(initialState, builder => {
  builder.addCase(completeLegacyBatch.fulfilled, state => {
    return {
      ...state,
      processing: "success",
    };
  });
  builder.addCase(completeLegacyBatch.pending, state => {
    return {
      ...state,
      processing: "pending",
    };
  });
  builder.addCase(completeLegacyBatch.rejected, state => {
    return {
      ...state,
      processing: "failed",
    };
  });
  builder.addCase(resetCompleteLegacyBatch, () => {
    return initialState;
  });
});
